import { CountdownTimer } from "./CountdownTimer/CountdownTimer";
import { useSelectedSession } from "../state";

export const ActiveSession = () => {
  const session = useSelectedSession()
  return (
    <>
      <span className="font-medium leading-tight text-3xl mt-0 mb-2 text-gray-700">
        {session.name}
      </span>
      <div className="w-1/2 mx-auto mt-12 p-6 bg-white border-gray-200 rounded-lg shadow hover:bg-gray-100 white:bg-gray-800 white:border-gray-700 white:hover:bg-gray-700">
        <CountdownTimer />
      </div>
    </>
  );
};
